angular.module('env.data.rest.model.modelDefinition', [])

    .factory('ModelDefinition', function (FieldDefinition) {

        var defaultModel = {
            idProperty: 'id',
            fields: {
                id: {}
            },
            validate: function () {
                return true;
            }
        };

        /**
         * Model definition
         * @param {string} modelDefinitionType unique type of model
         * @param {*} modelDefinitionConfiguration configuration of model
         * @param {*} allDefinitions all defined model definitions
         * @constructor
         */
        function ModelDefinition(modelDefinitionType, modelDefinitionConfiguration, allDefinitions) {
            this._modelDefinitionType = modelDefinitionType;
            this._modelDefinitionConfiguration = modelDefinitionConfiguration;
            this._allDefinitions = allDefinitions;

            this._errPrefix = _.str.sprintf("`%s` model definition error: ", this._modelDefinitionType);

            //region constructor

            if (!this._modelDefinitionType || !_.isString(this._modelDefinitionType)) {
                throw new Error(this._errPrefix + "model type must be set");
            }
            if (!this._modelDefinitionConfiguration) {
                throw new Error(this._errPrefix + "model definition config must be set");
            }
            if (!this._allDefinitions) {
                this._allDefinitions = [];
            }
            this.config = this._validateAndFixConfig(this.config);
            this.config = this._processParents(this.config);
            this.config = this._processFields(this.config);
            this.config = this._processCustomMethods(this.config);

            //endregion
        }

        /**
         * Validate config, fix missed fields, set default values
         * @param {*} cfg - config
         */
        ModelDefinition.prototype._validateAndFixConfig = function (cfg) {
            var _this = this;
            cfg = _.defaults(this._modelDefinitionConfiguration, defaultModel); // defaults
            cfg.type = this._modelDefinitionType;

            // region `extend` field

            var extend = [];
            if (cfg.extend) {
                if (_.isArray(cfg.extend)) {
                    _.forEach(cfg.extend, function (el) {
                        if (_.isString(el)) {
                            extend.push(el);
                        }
                    });
                } else if (_.isString(cfg.extend)) {
                    extend.push(cfg.extend);
                }
            }
            _.forEach(extend, function (el) {
                if (!_this._allDefinitions[el]) {
                    throw new Error(_this._errPrefix + "not all parents was initialized");
                }
            });
            cfg.extend = extend;

            // endregion

            return cfg;
        }

        ModelDefinition.prototype._processParents = function (cfg) {
            var oldExtend = cfg.extend.slice(0);
            var params = [true, {}].concat(this._getParentConfigs(cfg), cfg);
            cfg = $.extend.apply(null, params);
            cfg.extend = oldExtend;
            return cfg;
        }

        /**
         * Get array of parent configs (in order of it's definition)
         * @param cfg model definition config
         */
        ModelDefinition.prototype._getParentConfigs = function (cfg) {
            var _this = this;
            var parentConfigs = [];
            for (var i = 0; i < cfg.extend.length; i++) {
                var parentConfig = _this._allDefinitions[cfg.extend[i]].getConfig();
                parentConfigs.push(parentConfig);
            }
            return parentConfigs.reverse();
        }

        ModelDefinition.prototype._processFields = function (cfg) {
            var _this = this;
            this._fields = [];
            _.forEach(cfg.fields, function (fieldDefinition, filedName) {
                _this._fields.push(new FieldDefinition(filedName, fieldDefinition));
            });
            return cfg;
        }

        ModelDefinition.prototype._processCustomMethods = function (cfg) {
            var methods = {};
            if (cfg.methods) {
                _.forEach(cfg.methods, function (method, methodName) {
                    if (method && _.isFunction(method)) {
                        methods[methodName] = method;
                    }
                });
            }
            cfg.methods = methods;
            return cfg;
        }

        //region Public methods

        /**
         * Get model definition name
         * @returns {string} unique model definition name
         */
        ModelDefinition.prototype.getType = function () {
            return this.config.type;
        };

        /**
         * Get definition config
         * @returns {*}
         */
        ModelDefinition.prototype.getConfig = function () {
            return this.config;
        };

        /**
         * Get field definitions
         * @returns {Array} array of FieldDefinition
         */
        ModelDefinition.prototype.getFields = function () {
            return this._fields;
        };

        /**
         * Get route of current type
         * @returns {string}
         */
        ModelDefinition.prototype.getUrl = function () {
            return this.config.url || this.config.type;
        };

        /**
         * Get name of the model identifier property (must be unique for current definition)
         * @returns {string}
         */
        ModelDefinition.prototype.getIdPropertyName = function () {
            return this.config.idProperty || 'id';
        };

        /**
         * Create absolutely new model with default fields
         */
        ModelDefinition.prototype.newModel = function () {
            var newModel = {};

            _.forEach(this._fields, function (field) {
                if (!field.subResource) {
                    newModel[field.name] = field.defaultValue ? field.defaultValue : null;
                }
            });

            return newModel;
        };

        /**
         * Get custom methods
         * @returns {Array.<Function>}
         */
        ModelDefinition.prototype.getMethods = function () {
            return this.config.methods || {};
        };

        //endregion

        return (ModelDefinition);

    })

;
